import styled from 'styled-components';

export const ContainerScreens = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
`;

export const Container = styled.div`
  .kfIVFR ul {
    width: 400px !important;
  }
`;

export const ButtonItens = styled.button`
  display: flex;
  background: none;
  border: none;
  gap: 5px;
  align-items: center;
  height: 40px;
  padding: 10px;
  margin-top: 10px;
  svg {
    font-size: 16pt;
  }
  span {
    color: rgb(107, 119, 140);
  }
  &:hover {
    border: #4c9aff;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;
